import Link from "next/link";
import styles from "../styles/PartnerCard.module.css";
import Image from "next/image";
import { useRouter } from "next/router";

const partnerCard = ({ name, image, id, age, gender, date, description, buttonText, title ,View_More ,ageTitle}) => {

  const router = useRouter();

  const handleNavigation = () => {
    router.push({
      pathname: `/partnershipDetails/${id}`,
      query: { title: name }
    });
  };
  return (
    <div className={`${styles.card}  mb-2`}>
      <Image className="mb-2 rounded" src={image}
        width={0}
        height={0}
        sizes="100vw"
        style={{ width: "100%", height: "230px" , objectFit:'cover'}} />
      <h2 className={`${styles.nametext} mb-1`}>{name}</h2>
      <p className={`${styles.age} mb-2 text-muted`}>{age} {ageTitle}</p>
      <div className="d-flex gap-3">
        <p className="text-capitalize"><i className="secondarr-color bi bi-emoji-smile"></i> {gender}</p>
        <p><i className="secondarr-color bi bi-calendar-check"></i> {date}</p>
      </div>
      <p className="mb-4 line-2 text-muted">{description}</p>
      {/* <div className="text-center mb-2"><button onClick={handleNavigation} className="cta-btn sm-btn border-only">View More</button></div> */}
      <div className="text-center mb-2"> <a className="cta-btn sm-btn border-only" href={`/partnership-details?slug=${id}&title=${name}`} >{View_More}</a></div>
    </div>
  )
};

export default partnerCard;